<template>
  <v-dialog v-if="session"
            v-model="localDialog"
            persistent>
    <v-form :disabled="form.busy"
            @submit.prevent="submit">
      <v-card>
        <v-card-title>
          Mobile Locker Session {{ session.id }}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="session.presentation.name"
                            label="Presentation"
                            readonly
                            disabled>
              </v-text-field>
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="startedAt"
                            label="Date"
                            readonly
                            disabled>
              </v-text-field>
            </v-col>
          </v-row>

          <h3 class="mb-0">
            Associate this session with a Moxie Call Interaction.
          </h3>
          <v-radio-group v-model="form.crm_related_id"
                         class="mt-0">
            <v-data-table dense
                          :headers="headers"
                          :items="filteredCalls"
                          :items-per-page="20"
                          :footer-props="{'items-per-page-options': [10, 20, 50, 100]}">
              <template v-slot:item.action="{item: call}">
                <v-radio :value="call.Id">
                </v-radio>
              </template>

              <template v-slot:item.Name="{item: call}">
                <a :href="`https://allergannewmaorg.lightning.force.com/lightning/r/${call.Id}/view`"
                   target="_blank">
                  {{ call.Name }}
                </a>
              </template>

              <template v-slot:item.HCP_Account_Name__r.Name="{item: call}">
                <a v-if="call.HCP_Account_Name__c"
                   :href="`https://allergannewmaorg.lightning.force.com/lightning/r/${call.HCP_Account_Name__c}/view`"
                   target="_blank">
                  {{ call.HCP_Account_Name__r.Name }}
                </a>
              </template>

              <template v-slot:item.Personal_Contact__r.Name="{item: call}">
                <a v-if="call.Personal_Contact__c"
                   :href="`https://allergannewmaorg.lightning.force.com/lightning/r/${call.Personal_Contact__c}/view`"
                   target="_blank">
                  {{ call.Personal_Contact__r.Name }}
                </a>
              </template>

              <template v-slot:item.Parent_Call_Interaction__r.Name="{item: call}">
                <a v-if="call.Parent_Call_Interaction__c"
                   :href="`https://allergannewmaorg.lightning.force.com/lightning/r/${call.Parent_Call_Interaction__c}/view`"
                   target="_blank">
                  {{ call.Parent_Call_Interaction__r.Name }}
                </a>
              </template>

              <template v-slot:item.DateTime__c="{item: session}">
                {{ session.DateTime__c | datetime('M/D/YYYY h:mm a') }}
              </template>
            </v-data-table>
          </v-radio-group>
        </v-card-text>
        <v-card-actions>
          <v-btn type="submit"
                 color="primary"
                 :disabled="!formValid || form.busy">
            Submit
          </v-btn>
          <v-btn type="button"
                 :disabled="form.busy"
                 @click.prevent="closeDialog">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import axios from '../../../services/axiosService';
import {Form} from 'vform';
import {find} from 'lodash';
import moment from 'moment-timezone';
import DOMPurify from 'dompurify';

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
      required: false,
    },
    session: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      calls: [],
      form: new Form({
        crm_related_object: 'Call_Interaction__c',
        crm_related_id: '',
        crm_object_id: '',
      }),
      localDialog: this.dialog,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Action',
          value: 'action',
          cellClass: 'text-nowrap',
          width: '60px',
        },
        {
          text: 'Call Interaction',
          value: 'Name',
          cellClass: 'text-nowrap',
          width: '100px',
        },
        {
          text: 'Date/Time',
          value: 'DateTime__c',
          cellClass: 'text-nowrap',
        },
        {
          text: 'HCP/Account Name',
          value: 'HCP_Account_Name__r.Name',
        },
        {
          text: 'Account/Contact',
          value: 'Personal_Contact__r.Name',
        },
        {
          text: 'Parent Call',
          value: 'Parent_Call_Interaction__r.Name',
        },
        {
          text: 'Call Interaction Status',
          value: 'Call_Interaction_Status__c',
          cellClass: 'text-nowrap',
        },
        /*{
          text: 'Interaction Type',
          value: 'INTERACTION_TYPE_C__c',
        },*/
        /*{
          text: 'Duration',
          value: 'DURATION__c',
        },*/
        /*{
          text: 'Interaction Venue',
          value: 'INTERACTION_VENUE__c',
        },*/
      ]
    },
    filteredCalls() {
      return this.calls; // MLD-3305
      /*const sessionDate = moment(this.session.started_at);
      return this.calls.filter(c => {
        return moment(c.DateTime__c).isSame(sessionDate, 'day');
      });*/
    },
    formValid() {
      return !!this.form.crm_related_id;
    },
    startedAt() {
      return moment(this.session.started_at).format('M/D/YYYY h:mm a');
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    closeDialog() {
      this.localDialog = false;
      this.$emit('close')
    },
    async fetchData() {
      await this.getCalls();
    },
    getCalls() {
      return axios.get(`/api/clients/agnma/user/calls`)
        .then(response => {
          this.calls = response.data;
          return true;
        })
        .catch(err => {

        })
    },
    submit() {
      const call = find(this.calls, c => c.Id === this.form.crm_related_id)
      if (call) {
        const question = `Are you sure you want to associate this session with call ${DOMPurify.sanitize(call.Name)}?`;
        if (!confirm(question)) {
          return;
        }
        this.form.put(`/api/clients/agnma/device-sessions/${this.session.id}`)
          .then(response => {
            setTimeout(() => {
              this.localDialog = false;
              this.$emit('updated');
            }, 2000);
          })
          .catch(err => {
            if (err.response && err.response.data) {
              this.$toast.error(DOMPurify.sanitize(err.response.data.message));
            }
            this.localDialog = false;
            this.$emit('updated');
          })
      } else {
        this.$toast.error(`Call ${DOMPurify.sanitize(this.form.crm_related_id)} not found`);
      }
    }
  }
}
</script>
